/* AFS7 - de abonnementstoestemming rustiger, zonder iets te verbergen.

   Shopify zet zelf <small id="shopify-buyer-consent"> in het wallet-blok zodra
   er een abonnementsregel in de cart ligt. Die tekst is verplicht.

   Wat dit doet
   ------------
   De KERN blijft altijd staan, in gewone taal: dit is een abonnement en er wordt
   herhaaldelijk afgeschreven tot je opzegt. Alleen de juridische formulering van
   Shopify vouwt open achter een knop. Er wordt dus niets weggehaald en niets
   achter een klik verstopt wat iemand moet weten voordat hij afrekent - de
   volledige tekst staat er nog, een tik verderop.

   Belangrijk: het element van Shopify zelf wordt VERPLAATST, niet nagebouwd.
   Shopify hangt een click-handler aan #shopify-subscription-policy-button om het
   annuleringsbeleid te openen. Zou ik de inhoud opnieuw opbouwen, dan gaat die
   handler verloren en opent dat beleid niet meer. */
(function () {
  'use strict';
  if (window.__afs7Consent) return;
  window.__afs7Consent = true;

  var CFG = window.__afs7ConsentText || {};

  function build(el) {
    if (!el || el.__afs7done) return;
    if (el.closest('.afs7-consent')) return;
    el.__afs7done = true;

    var wrap = document.createElement('div');
    wrap.className = 'afs7-consent';

    var head = document.createElement('div');
    head.className = 'afs7-consent__head';

    var eb = document.createElement('span');
    eb.className = 'afs7-consent__eb';
    eb.textContent = CFG.label || 'Subscription';

    var sum = document.createElement('p');
    sum.className = 'afs7-consent__sum';
    sum.textContent = CFG.summary ||
      'This order contains a subscription. You will be charged again automatically at the price and frequency shown above, until you cancel.';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'afs7-consent__more';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', 'shopify-buyer-consent');
    btn.textContent = CFG.more || 'Read the full terms';

    head.appendChild(eb);
    head.appendChild(sum);
    head.appendChild(btn);

    el.parentNode.insertBefore(wrap, el);
    wrap.appendChild(head);
    wrap.appendChild(el); // verplaatsen, niet nabouwen
    el.hidden = true;

    btn.addEventListener('click', function () {
      var open = el.hidden;
      el.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? (CFG.less || 'Hide the full terms')
                             : (CFG.more || 'Read the full terms');
    });
  }

  function init() { build(document.getElementById('shopify-buyer-consent')); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else { init(); }
  document.addEventListener('afs2:cart-updated', function () { setTimeout(init, 60); });
  document.addEventListener('shopify:section:load', init);

  /* Shopify voegt het blok pas toe zodra de wallet-knoppen geladen zijn, en
     opnieuw na een cartwijziging. Kijken tot het er is. */
  if ('MutationObserver' in window) {
    new MutationObserver(function () { init(); })
      .observe(document.body, { childList: true, subtree: true });
  }
  setTimeout(init, 1200);
  setTimeout(init, 3000);
})();